import { render, staticRenderFns } from "./SwiperBox.vue?vue&type=template&id=3479d168&scoped=true"
import script from "./SwiperBox.vue?vue&type=script&lang=js"
export * from "./SwiperBox.vue?vue&type=script&lang=js"
import style0 from "./SwiperBox.vue?vue&type=style&index=0&id=3479d168&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479d168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/chaoangoods.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3479d168')) {
      api.createRecord('3479d168', component.options)
    } else {
      api.reload('3479d168', component.options)
    }
    module.hot.accept("./SwiperBox.vue?vue&type=template&id=3479d168&scoped=true", function () {
      api.rerender('3479d168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swiper/SwiperBox.vue"
export default component.exports